{
  "title": "Paramètres",
  "tabs": {
    "provider": "Fournisseur",
    "connection": "Connexion",
    "appearance": "Apparence",
    "agent": "Agent",
    "features": "Fonc.",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Thème",
    "themeLight": "Clair",
    "themeDark": "Sombre",
    "themeSystem": "Système",
    "themeSystemHint": "Système suit votre préférence clair/sombre définie au niveau du système d'exploitation.",
    "preferencesHeading": "Préférences",
    "compactDensity": "Densité compacte",
    "compactDensityHint": "Espacement plus serré dans tout le chat.",
    "soundOnComplete": "Son à la fin de l'exécution",
    "soundOnCompleteHint": "Émet une douce sonnerie quand une exécution se termine.",
    "titleAnimation": "Animation du titre",
    "titleAnimationHint": "Affiche un titre de terminal animé dans le CLI.",
    "languageHeading": "Langue",
    "languageLabel": "Langue de l'interface",
    "languageHint": "Modifie uniquement le texte de l'interface. Les prompts, les compétences et la sortie du modèle ne sont pas affectés."
  },
  "model": {
    "heading": "Modèle",
    "loading": "Chargement des modèles...",
    "notFound": "Aucun modèle trouvé pour ce fournisseur. Le catalogue est peut-être vide ou en cours de chargement.",
    "selectProviderFirst": "Sélectionnez d'abord un fournisseur",
    "context": "{{count}}k contexte"
  },
  "connection": {
    "wsUrlLabel": "URL du serveur WebSocket",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL du serveur WebSocket de l'agent. Le serveur fonctionne en parallèle du CLI.",
    "startingHeading": "Démarrage du serveur WebSocket",
    "startingBody": "Autonome : lancez ./dev.ps1 depuis la racine du repo, ou définissez WS_HOST/WS_PORT avant de lancer wstackui. Ou avec la CLI : wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Connexion par abonnement",
    "apiKeysHeading": "Fournisseurs de clés API",
    "apiKeysBody": "Choisissez un fournisseur dans le catalogue et ajoutez une clé API, ou gérez les fournisseurs enregistrés.",
    "tabCatalog": "Catalogue",
    "tabSaved": "Enregistrés ({{count}})",
    "searchPlaceholder": "Rechercher {{count}} fournisseurs (nom / id / famille)…",
    "loadingCatalog": "Chargement du catalogue...",
    "noMatch": "Aucun fournisseur ne correspond à « {{query}} ».",
    "configured": "Configuré",
    "reachable": "Accessible",
    "envVar": "ENV : {{var}}",
    "modelCount_one": "{{count}} modèle",
    "modelCount_other": "{{count}} modèles",
    "keyPlaceholder": "Clé API {{name}}",
    "orEnv": "Ou définissez {{env}} dans l'environnement à la place.",
    "addApiKey": "Ajouter une clé API",
    "manageKeys": "Gérez vos clés API et configurations de fournisseur",
    "addProvider": "Ajouter un fournisseur",
    "addCustomHeading": "Ajouter un fournisseur personnalisé",
    "localServers": "Serveurs locaux — cliquez pour pré-remplir :",
    "providerIdPlaceholder": "ID du fournisseur (ex. my-llm-server)",
    "apiKeyOptionalPlaceholder": "Clé API (facultatif)",
    "noSaved": "Aucun fournisseur enregistré",
    "noSavedHint": "Ajoutez un fournisseur pour démarrer",
    "apiKeysLabel": "Clés API",
    "addKey": "Ajouter une clé",
    "noKeys": "Aucune clé configurée",
    "active": "Active",
    "setActive": "Définir comme active",
    "keyLabelPlaceholder": "Libellé de la clé (ex. default, production)",
    "apiKeyPlaceholder": "Clé API",
    "saveKey": "Enregistrer la clé",
    "savedToast": "Clé enregistrée pour {{name}}"
  },
  "mcp": {
    "status": {
      "connected": "Connecté",
      "connecting": "Connexion",
      "sleeping": "En veille",
      "discovering": "Découverte",
      "error": "Erreur",
      "stopped": "Arrêté",
      "unknown": "Inconnu"
    },
    "disabled": "Les serveurs MCP sont désactivés.",
    "wakeTitle": "Réveiller le serveur",
    "sleepTitle": "Mettre en veille",
    "discoverTitle": "Découvrir les outils",
    "editTitle": "Modifier",
    "removeTitle": "Supprimer",
    "statusLabel": "Statut :",
    "enabledLabel": "Activé :",
    "yes": "Oui",
    "no": "Non",
    "descriptionLabel": "Description :",
    "pidLabel": "PID :",
    "errorLabel": "Erreur :",
    "toolsLabel": "Outils ({{count}}) :",
    "noTools": "Aucun outil découvert pour le moment",
    "serverNameRequired": "Le nom du serveur est requis",
    "dialogTitleEdit": "Modifier le serveur MCP",
    "dialogTitleAdd": "Ajouter un serveur MCP",
    "dialogTitleAddCustom": "Ajouter un serveur MCP personnalisé",
    "fieldName": "Nom",
    "fieldNamePlaceholder": "ex. github, filesystem",
    "fieldTransport": "Transport",
    "fieldUrl": "URL",
    "fieldCommand": "Commande",
    "fieldCommandPlaceholder": "ex. npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(séparés par des espaces)",
    "fieldArgsPlaceholder": "ex. -y @modelcontextprotocol/server-github",
    "fieldEnv": "Variables d'env",
    "fieldEnvHint": "(KEY=valeur, une par ligne)",
    "fieldDescription": "Description",
    "fieldDescriptionPlaceholder": "Serveur MCP GitHub pour l'accès au dépôt",
    "enableServer": "Activer le serveur",
    "lazyConnect": "Connexion différée",
    "lazyConnectHint": "(ne démarre qu'au premier appel d'outil ; se met en veille quand inactif)",
    "saveChanges": "Enregistrer",
    "addServer": "Ajouter le serveur",
    "requires": "Requiert : {{vars}}",
    "added": "Ajouté",
    "heading": "Serveurs MCP",
    "summary": "{{connected}} connecté(s) · {{sleeping}} en veille · {{total}} au total",
    "addCustom": "Personnalisé",
    "tabRecommended": "Recommandés",
    "tabServers": "Serveurs",
    "tabAddCustom": "Personnalisé",
    "recommendedBody": "Ajout en un clic pour les serveurs MCP populaires. Cliquez sur Ajouter pour pré-remplir la configuration, puis confirmez. Les serveurs nécessitant des identifiants devront avoir leurs variables d'env définies avant usage.",
    "loadingServers": "Chargement des serveurs...",
    "noServers": "Aucun serveur MCP configuré",
    "noServersHint": "Passez à l'onglet Recommandés pour ajouter des serveurs populaires, ou Personnalisé pour les vôtres.",
    "addCustomBody": "Configurez un serveur MCP personnalisé avec transport stdio, SSE ou HTTP.",
    "addCustomBodyHint": "Pour les serveurs populaires, utilisez plutôt l'onglet Recommandés — tout est préconfiguré.",
    "removeConfirmTitle": "Supprimer le serveur « {{name}} » ?",
    "removeConfirmBody": "Cela supprime le serveur MCP de votre configuration.",
    "toastAdded": "Serveur « {{name}} » ajouté",
    "toastRemoved": "Serveur « {{name}} » supprimé",
    "toastDiscovered": "{{count}} outils découverts depuis « {{name}} »",
    "toastSleeping": "Le serveur « {{name}} » est en veille",
    "toastConnected": "Serveur « {{name}} » connecté",
    "toastReconnected": "Serveur « {{name}} » reconnecté",
    "toastDisconnected": "Serveur « {{name}} » déconnecté : {{reason}}",
    "toastError": "Serveur « {{name}} » erreur : {{error}}",
    "disabledHint": "Activez l'indicateur « Serveurs MCP » dans l'onglet Fonctionnalités pour utiliser cette section."
  },
  "allowlist": {
    "title": "Effacer la allowlist enregistrée ?",
    "body_one": "Cela supprimera le modèle épinglé pour {{provider}}. Le sélecteur de modèle reviendra au catalogue models.dev.",
    "body_other": "Cela supprimera les {{count}} modèles épinglés pour {{provider}}. Le sélecteur de modèle reviendra au catalogue models.dev.",
    "undoHint": "Vous pouvez annuler pendant 8 secondes après confirmation.",
    "keepTitle": "Conserver l'allowlist (Échap)",
    "clearTitle": "Effacer l'allowlist (Entrée)",
    "clear": "Effacer l'allowlist"
  },
  "oauth": {
    "termsWarning": "Connectez-vous avec un abonnement au lieu d'une clé API. Utiliser un abonnement en dehors de son client officiel peut enfreindre les Conditions du fournisseur — votre compte pourrait être limité ou banni. Une clé API est la voie sanctifiée pour un usage programmatique.",
    "signIn": "Se connecter",
    "waitingBrowser": "En attente de votre connexion…",
    "openSignIn": "Ouvrir la page de connexion",
    "pasteLoopbackBusy": "Port loopback occupé — collez l'URL de redirection",
    "pasteCantReach": "Le navigateur n'atteint pas ce serveur ? Collez l'URL de redirection",
    "submit": "Soumettre",
    "enterCode": "Saisissez ce code sur la page de vérification :",
    "openVerification": "Ouvrir la page de vérification",
    "waitingCode": "En attente d'autorisation…",
    "exchanging": "Échange des tokens…",
    "fetchingModels": "Récupération des modèles…",
    "signedIn": "Connecté.",
    "signedInToast": "Connecté — {{provider}}",
    "signInFailed": "Échec de la connexion"
  },
  "agent": {
    "modelHeading": "Modèle",
    "autonomyHeading": "Autonomie & Comportement",
    "autonomyModeLabel": "Mode d'autonomie",
    "autonomyModeHint": "Indépendance de l'agent entre les tours.",
    "autonomyModeOff": "Désactivé — contrôle manuel complet",
    "autonomyModeSuggest": "Suggérer — suggère les prochaines étapes",
    "autonomyModeAuto": "Auto — court délai de confirmation",
    "autonomyModeEternal": "Éternel — autonome jusqu'à la fin de l'objectif",
    "autonomyModeEternalParallel": "Éternel Parallèle — flotte multi-agents",
    "autoProceedDelayLabel": "Délai d'avance automatique",
    "autoProceedDelayHint": "Millisecondes avant que l'agent avance automatiquement en mode Auto. 0 = immédiat.",
    "yoloLabel": "Mode YOLO",
    "yoloHint": "Contourner les confirmations d'outils — l'agent s'exécute sans demander.",
    "refineHeading": "Affinage du prompt",
    "enableRefineLabel": "Activer l'affinage",
    "enableRefineHint": "Réécrire les prompts avant l'envoi — instructions plus claires, meilleurs résultats.",
    "refineDelayLabel": "Délai d'affinage",
    "refineDelayHint": "Compte à rebours avant l'envoi automatique du prompt affiné.",
    "refineLanguageLabel": "Langue d'affinage",
    "refineLanguageHint": "Conserver votre langue ou traduire en anglais pour le modèle.",
    "refineLanguageOriginal": "Original — conserver votre langue",
    "refineLanguageEnglish": "Anglais — traduire en anglais",
    "reasoningHeading": "Raisonnement & Cache",
    "reasoningModeLabel": "Mode de raisonnement",
    "reasoningModeHint": "Contrôler comment le modèle utilise la pensée étendue. Auto = valeur du fournisseur.",
    "reasoningModeAuto": "Auto — valeur du fournisseur",
    "reasoningModeOn": "Activé — forcer la pensée",
    "reasoningModeOff": "Désactivé — désactiver la pensée",
    "reasoningEffortLabel": "Effort de raisonnement",
    "reasoningEffortHint": "Quantité de calcul que le modèle consacre à la pensée. Envoyé seulement si le modèle le supporte.",
    "reasoningEffortNone": "Aucun",
    "reasoningEffortMinimal": "Minimal",
    "reasoningEffortLow": "Faible",
    "reasoningEffortMedium": "Moyen",
    "reasoningEffortHigh": "Élevé",
    "reasoningEffortXhigh": "Très élevé",
    "reasoningEffortMax": "Max",
    "preserveThinkingLabel": "Préserver la pensée",
    "preserveThinkingHint": "Conserver les blocs de raisonnement entre les tours pour la continuité du contexte.",
    "cacheTtlLabel": "TTL du cache",
    "cacheTtlHint": "Durée de vie du cache de prompt. 1h coûte plus à l'écriture mais économise en relectures (Anthropic).",
    "cacheTtlDefault": "Par défaut — valeur du fournisseur",
    "cacheTtl5m": "5 minutes",
    "cacheTtl1h": "1 heure",
    "capsHint": "Utilisez wstack models caps pour vérifier ce que le modèle actuel supporte. Les réglages non supportés sont omis silencieusement par requête.",
    "fallbackHeading": "Fallbacks de modèle",
    "fallbackBody": "Quand le modèle actif est rate-limité (429/529), en erreur 5xx ou bloqué — après ses propres retries — l'agent passe au modèle suivant de cette chaîne. Aussi utilisé par défaut pour les sous-agents workers SDD.",
    "autoFallbackLabel": "Fallback auto",
    "autoFallbackHint": "Quand la chaîne ci-dessus est vide, en dériver une automatiquement depuis vos fournisseurs clés.",
    "favoritesOnlyLabel": "Favoris uniquement",
    "favoritesOnlyHint": "Quand le fallback auto dérive une chaîne, la restreindre à vos modèles favoris.",
    "profilesHeading": "Profils de fallback",
    "addProfile": "Ajouter",
    "noProfiles": "Aucun profil de fallback nommé pour l'instant.",
    "createDefault": "Créer le défaut depuis le modèle actif",
    "useChain": "Utiliser la chaîne",
    "setLeader": "Définir le leader",
    "profileEmpty": "Le profil est vide.",
    "favoritesHeading": "Modèles favoris",
    "favoritesEmpty": "Les favoris sont affichés en premier et peuvent contraindre le fallback auto.",
    "routingHeading": "Routage de modèle",
    "routingRouteKey": "Clé de route de modèle",
    "routingPhasesGroup": "Phases",
    "routingRolesGroup": "Rôles {{label}}",
    "routingCustomGroup": "Routes personnalisées existantes",
    "routingTargetPlaceholder": "fallback1, provider/model, ou vide",
    "routingSet": "Définir",
    "routingReasoningModeAria": "Mode de raisonnement nouvelle route",
    "routingReasoningEffortAria": "Effort de raisonnement nouvelle route",
    "routingReasoningPreserveAria": "Préservation raisonnement nouvelle route",
    "routingReasoningModeFor": "Mode de raisonnement pour {{key}}",
    "routingReasoningEffortFor": "Effort de raisonnement pour {{key}}",
    "routingReasoningPreserveFor": "Préservation raisonnement pour {{key}}",
    "noRoutes": "Aucune route de modèle pour l'instant.",
    "leaderModel": "modèle leader",
    "hqHeading": "Client HQ",
    "hqPublishingLabel": "Publication HQ",
    "hqPublishingHint": "Publier cette session WebUI/client vers WrongStack HQ. Les clients de même machine peuvent auto-découvrir l'auth HQ locale ; les clients distants utilisent l'URL/token ci-dessous.",
    "hqUrlLabel": "URL HQ",
    "hqUrlHint": "Laisser vide pour l'auto-découverte sur même machine.",
    "hqTokenLabel": "Token client HQ",
    "executionHeading": "Exécution",
    "maxIterationsLabel": "Itérations max par run",
    "maxIterationsHint": "Plafond strict de tours LLM par agent.run().",
    "autoProceedMaxIterationsLabel": "Itérations max d'avance auto",
    "autoProceedMaxIterationsHint": "Arrêter l'avance auto après N itérations. 0 = illimité.",
    "confirmExitLabel": "Confirmer avant de quitter",
    "confirmExitHint": "Premier Ctrl+C annule le travail, second confirme la sortie.",
    "chimeLabel": "Carillon à la fin",
    "chimeHint": "Cloche du terminal quand un run d'agent se termine.",
    "fleetHeading": "Flotte & Streaming",
    "streamFleetLabel": "Streamer les événements de flotte",
    "streamFleetHint": "Afficher l'activité live des sous-agents dans le panneau de flotte.",
    "maxConcurrentLabel": "Sous-agents simultanés max",
    "maxConcurrentHint": "Nombre maximum de sous-agents pouvant tourner simultanément.",
    "nextPredictionLabel": "Prédiction des prochaines étapes",
    "nextPredictionHint": "Après un tour, prédire les prochaines étapes probables.",
    "telegramHeading": "Notifications Telegram",
    "telegramSessionEndLabel": "Fin de session",
    "telegramSessionEndHint": "Envoyer un résumé quand une session se termine.",
    "telegramDelegateLabel": "Délégué terminé",
    "telegramDelegateHint": "Envoyer une note humanisée quand un sous-agent termine.",
    "telegramLongToolLabel": "Outils longs",
    "telegramLongToolHint": "Notifier quand un outil dépasse {{ms}}ms. 0 pour désactiver.",
    "telegramChangesApply": "Les changements s'appliquent immédiatement.",
    "telegramNotConfigured": "Telegram n'est pas configuré. Lancez /telegram-setup dans la CLI pour connecter un bot d'abord.",
    "addModelToProfile": "Ajouter un modèle au profil…",
    "addFavoriteModel": "Ajouter un modèle favori…",
    "hqRawContentLabel": "Contenu HQ brut",
    "hqRawContentHint": "Envoyer des aperçus de contenu bruts à HQ au lieu d'aperçus caviardés."
  },
  "features": {
    "flagsHeading": "Indicateurs de fonctionnalités",
    "mcpLabel": "Serveurs MCP",
    "mcpHint": "Activer les intégrations Model Context Protocol.",
    "pluginsLabel": "Plugins",
    "pluginsHint": "Charger et exécuter les plugins installés par l'utilisateur.",
    "memoryLabel": "Mémoire",
    "memoryHint": "Persister et rappeler des faits entre les sessions.",
    "skillsLabel": "Compétences",
    "skillsHint": "Charger les prompts de compétences spécifiques au domaine.",
    "modelsRegistryLabel": "Registre des modèles",
    "modelsRegistryHint": "Utiliser le catalogue models.dev pour la découverte des fournisseurs.",
    "indexOnStartLabel": "Indexer au démarrage",
    "indexOnStartHint": "Construire l'index des symboles du codebase au démarrage de la session.",
    "contextHeading": "Contexte & Débogage",
    "autoCompactLabel": "Compacter le contexte auto",
    "autoCompactHint": "Réduire automatiquement la fenêtre de contexte près des limites.",
    "compactorStrategyLabel": "Stratégie de compactage",
    "compactorStrategyHint": "Comment le contexte est compacté quand il devient trop grand.",
    "compactorStrategyHybrid": "Hybride — règles rapides (défaut)",
    "compactorStrategyIntelligent": "Intelligent — résumé LLM",
    "compactorStrategySelective": "Sélectif — sélection pilotée par LLM",
    "contextModeLabel": "Mode de contexte",
    "contextModeHint": "Politique de fenêtre de contexte — équilibré par défaut.",
    "contextModeBalanced": "Équilibré — usage normal du contexte",
    "contextModeFrugal": "Frugal — usage conservateur de tokens",
    "contextModeDeep": "Profond — contexte plus large pour tâches complexes",
    "contextModeArchival": "Archival — maximiser la rétention de contexte",
    "tokenSavingLabel": "Mode d'économie de tokens",
    "tokenSavingHint": "Quelle agressivité pour réduire l'usage des tokens.",
    "tokenSavingOff": "Désactivé — aucune économie",
    "tokenSavingMinimal": "Minimal — optimisation de base",
    "tokenSavingLight": "Léger — réduction modérée",
    "tokenSavingMedium": "Moyen — économies significatives",
    "tokenSavingAggressive": "Agressif — compression maximale",
    "logLevelLabel": "Niveau de log",
    "logLevelHint": "Sévérité minimale pour le logging côté serveur.",
    "logLevelDebug": "Debug — tout",
    "logLevelInfo": "Info — flux normal",
    "logLevelWarn": "Warn — problèmes uniquement",
    "logLevelError": "Error — échecs uniquement",
    "auditLevelLabel": "Niveau d'audit",
    "auditLevelHint": "Niveau de détail pour les logs d'audit de session.",
    "auditLevelMinimal": "Minimal — erreurs uniquement",
    "auditLevelStandard": "Standard — appels d'outils + erreurs",
    "auditLevelFull": "Complet — chaque événement (logs volumineux)"
  },
  "toast": {
    "switchingTo": "Basculement vers {{provider}} / {{model}}…",
    "fallbackExists": "Le profil de fallback « {{name}} » existe déjà",
    "selectProviderModelFirst": "Sélectionnez d'abord un fournisseur et un modèle",
    "defaultProfileCreated": "Profil de fallback par défaut créé",
    "profileEmpty": "Le profil de fallback « {{name}} » est vide",
    "leaderSetFrom": "Leader défini depuis {{name}}"
  }
}
